import { render } from "./pb-pagehomeproperties.vue?vue&type=template&id=0f045b64"
import script from "./pb-pagehomeproperties.vue?vue&type=script&lang=js"
export * from "./pb-pagehomeproperties.vue?vue&type=script&lang=js"

import "./pb-pagehomeproperties.vue?vue&type=style&index=0&id=0f045b64&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__